export default __webpack_public_path__ + "static/close-icon-e4c961e0d9c64339e00a4e318bf0941f.svg";